export enum DocumentTypes {
  DNI = 1,
  CUIL = 2,
  CUIT = 3,
}
